var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { TypographyBody, TypographyHeading } from '@honeycomb/ui-core';
import React from 'react';
export function WishlistHeading(_a) {
    var { title, description } = _a, others = __rest(_a, ["title", "description"]);
    return (React.createElement("div", null,
        React.createElement(TypographyHeading, Object.assign({ color: "common.black", size: "s", component: "h1", weight: "bold" }, others), title),
        description && (React.createElement(TypographyBody, { component: "div", size: "s", mt: 2 }, description))));
}
